<template>
  <div class="row sharing-exp-pass">
    <form>
      <div v-if="!edit_mode" class="col-md-12">
        <div v-if="has_expiration" class="form-group">
          {{ $t('share_invite.link_expires_on', {date: formatDate(this.$props.expired_at)}) }} ( <a href="#" @click="addPassword()">{{ $t('share_invite.change_date') }}</a> )
        </div>
        <div v-else class="form-group">
          <a href="#" @click="addPassword()">{{ $t('share_invite.add_exp_date') }}</a>
        </div>
      </div>
      <div v-else class="col-md-12">
        <div class="row">
          <div class="col-md-6 input-group">
            <datepicker ref="expDatepicker" :value="expired_at" @selected="submitForm" :disabled-dates="{to: new Date()}" input-class="form-control expiration-input"></datepicker>
            <div class="input-group-append" @click.prevent="datepickerFocus()">
              <span class="input-group-text"><i class="fas fa-calendar"></i></span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
          <span>
            {{ $t('share_invite.time_zone') }}
          </span>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

export default {
  components: {
    datepicker: Datepicker
  },
  props: ['folder_id', 'has_expiration', 'expired_at', 'timezone'],
  data() {
    return {
      edit_mode: false
    }
  },
  methods: {
      addPassword() {
        this.edit_mode = true
      },
      submitForm(selected_date) {
        let formData = new FormData()

        formData.append('folder[sharing_expired_at]', selected_date)

        this.axios.patch('/folders/' + this.$props.folder_id + '/settings/', formData).then(({data}) => {
          if(selected_date) {
            this.$toastr.success(this.$t('shared.updated_successfully'))
            this.store.sendMetrics({name: 'add_folder_sharing_expiration', params: this.$route.params, path: this.$route.fullPath})
            this.$emit('reload-settings')
            this.edit_mode = false
          }
        })
      },
      datepickerFocus: function(){
        $('#folder-sharing-expired-at').focus()
      }
  }
}
</script>
